import React from "react";

const PaymentSuccess = ({ onOk }) => (
  <div className="flex flex-col items-center justify-center py-12">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide-icon text-green-500 mb-4"
    >
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
    <h3 className="text-2xl font-bold text-green-600 mb-4">
      Payment Successful!
    </h3>
    <p className="text-lg text-gray-700 mb-4 text-center">
      Thank you for shopping with Kickin' w/ Crews!
      <br />
      You will receive a confirmation email shortly.
    </p>
    <button
      onClick={onOk}
      className="py-3 px-8 bg-indigo-600 text-white rounded-full shadow-lg hover:bg-indigo-700 transition-colors font-bold text-xl mt-4"
    >
      OK
    </button>
  </div>
);

export default PaymentSuccess;